import { render, staticRenderFns } from "./Gif.vue?vue&type=template&id=90c57390&scoped=true&"
import script from "./Gif.vue?vue&type=script&lang=js&"
export * from "./Gif.vue?vue&type=script&lang=js&"
import style0 from "./Gif.vue?vue&type=style&index=0&id=90c57390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c57390",
  null
  
)

export default component.exports